/**
 * Says where a task came from when nobody typed it in (OL-210), for example
 * "Auto · Demand letter". Renders nothing for a task a person made.
 */
const SourceBadge = ({ label }) => {
  if (!label) return null;

  return (
    <span
      className="badge badge-sm badge-outline badge-info whitespace-nowrap"
      title={`Created automatically from a ${label.toLowerCase()}`}
    >
      Auto · {label}
    </span>
  );
};

/** The Title cell of the task lists: the title, then the source badge. */
const TaskTitle = ({ reminder }) => (
  <span className="inline-flex flex-wrap items-center gap-1.5">
    <span>{reminder.title}</span>
    <SourceBadge label={reminder.source_label} />
  </span>
);

export { SourceBadge, TaskTitle };
